import { useState, useEffect, useRef } from 'react'
import type { AgentLoadingState } from './useAgentLoadingState'
import { PHRASE_INTERVAL_MS } from './useChatStatusPhases'

export interface BrowsePhaseProgress {
    browsePhaseVisible: boolean
    browsingChildVisible: boolean
    browsingDoneVisible: boolean
}

const useBrowsePhaseProgress = (loadingState: AgentLoadingState): BrowsePhaseProgress => {
    const [browsePhaseVisible, setBrowsePhaseVisible] = useState(false)
    const [browsingChildVisible, setBrowsingChildVisible] = useState(false)
    const [browsingDoneVisible, setBrowsingDoneVisible] = useState(false)

    const prevLoadingStateRef = useRef<AgentLoadingState>('idle')

    useEffect(() => {
        const prev = prevLoadingStateRef.current
        prevLoadingStateRef.current = loadingState

        if (loadingState === 'idle') {
            setBrowsePhaseVisible(false)
            setBrowsingChildVisible(false)
            return
        }

        if (loadingState === 'responding') {
            setBrowsePhaseVisible(true)
            return
        }

        if (prev !== 'idle' && prev !== 'responding') return

        setBrowsePhaseVisible(false)
        setBrowsingChildVisible(false)
        const timer = setTimeout(() => setBrowsePhaseVisible(true), PHRASE_INTERVAL_MS)
        return () => clearTimeout(timer)
    }, [loadingState])

    useEffect(() => {
        if (!browsePhaseVisible) {
            setBrowsingChildVisible(false)
            setBrowsingDoneVisible(false)
            return
        }
        const timer = setTimeout(() => setBrowsingChildVisible(true), Math.floor(PHRASE_INTERVAL_MS / 6))
        return () => clearTimeout(timer)
    }, [browsePhaseVisible])

    useEffect(() => {
        if (!browsingChildVisible) {
            setBrowsingDoneVisible(false)
            return
        }
        const timer = setTimeout(() => setBrowsingDoneVisible(true), Math.floor(PHRASE_INTERVAL_MS / 6))
        return () => clearTimeout(timer)
    }, [browsingChildVisible])

    return { browsePhaseVisible, browsingChildVisible, browsingDoneVisible }
}

export default useBrowsePhaseProgress
